export const reload = () => document?.location?.reload()